import script from "./aiColorMatchingTab.vue?vue&type=script&setup=true&name=aiColorMatching&lang=js"
export * from "./aiColorMatchingTab.vue?vue&type=script&setup=true&name=aiColorMatching&lang=js"

import "./aiColorMatchingTab.vue?vue&type=style&index=0&id=67c79e06&lang=css"

const __exports__ = script;

export default __exports__